export default {
  'investing-brokerage': {
    category: 'Brokers Offers',
    quantcastLabel: 'Vertical.Investing.Clicks',
    productType: 'investing',
  },
  'investing-offers': {
    category: 'Investing Offers',
    quantcastLabel: 'Vertical.Investing.Clicks',
    eventFields: [
      'institutionName',
      'productName',
      'productType',
      'offerName',
      'offerAccountType',
      'offerReviewType',
    ],
    specialDisclaimers: {
      wealthfront: 'wealthfront',
      'personal-capital-2': 'personalcapital',
      'marcus-invest': 'marcusinvest',
      'merrill-edge': 'merrilledge',
      'merrill-edge-ira': 'merrilledgeira',
    },
    productType: 'investing',
  },
  'credit-cards': {
    category: 'Credit Card',
    quantcastLabel: 'Vertical.Credit Cards.Clicks',
    gtmEvent: 'conversion_cc',
    productType: 'credit_cards',
    queryParams: [
      'creditScoreFilter',
      'feesFilter',
      'yearsWithCardFilter',
      'monthlySpendFilter',
      'cardNetworkFilter',
      'financialInstitutionsFilter',
      'annualFee',
      'issuer',
      'balanceTransferFee',
      'creditCardRank',
      'categoryRank',
    ],
  },
  'banking-rate': {
    category: 'Banking Rate',
    quantcastLabel: 'Vertical.Banking.Clicks',
    gtmEvent: 'conversion_banking',
    productType: 'banking',
  },
  'smb-offer': {
    category: 'SMB Offers',
    quantcastLabel: 'Vertical.Small Business.Clicks',
    productType: 'small_medium_business_loans',
  },
  'personal-loan-offer': {
    category: 'Personal Loans Offers',
    quantcastLabel: 'Vertical.Loans.Clicks',
    productType: 'personal_loans',
  },
  'banking-money-transfer': {
    category: 'Money Transfer',
    productType: 'banking',
  },
  'edu-offer': {
    category: 'EDU Offers',
    quantcastLabel: 'Vertical.EDU.Clicks',
    productType: 'education_loans',
  },
  'network-links': {
    category: 'Generic/Network Link',
  },
};
